import axios from './axios';

// 🔹 取得所有啟用的文章標籤 (公開)
export function getEnabledArticleTags() {
    return axios.get('/api/cms/article-tags/enabled').then(res => res.data);
}

// 🔹 分頁查詢所有文章標籤 (需管理員權限)
export function getArticleTagPage(page = 0, size = 10, sort = 'createdAt,desc') {
    return axios.get('/api/cms/article-tags', {
        params: { page, size, sort }
    }).then(res => res.data);
}

// 🔹 取得單一文章標籤 (需管理員權限)
export function getArticleTagById(id) {
    return axios.get(`/api/cms/article-tags/${id}`).then(res => res.data);
}

// 🔹 新增文章標籤 (需管理員權限)
export function createArticleTag(tag) {
    return axios.post('/api/cms/article-tags', tag).then(res => res.data);
}

// 🔹 更新文章標籤 (需管理員權限)
export function updateArticleTag(id, tag) {
    return axios.put(`/api/cms/article-tags/${id}`, tag).then(res => res.data);
}

// 🔹 刪除文章標籤 (需管理員權限)
export function deleteArticleTag(id) {
    return axios.delete(`/api/cms/article-tags/${id}`).then(res => res.status === 200 || res.status === 204);
}